export default __webpack_public_path__ + "proximanova-thin-webfont.woff2";